var map = {
	"./en/role-1/title.png": "BQZt",
	"./en/role-2/title.png": "NRT7",
	"./en/role-3/title.png": "JGir",
	"./en/role-4/title.png": "KoLE",
	"./en/role-5/title.png": "N4lJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W+di";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/.*\/title\.png$
// module id = W+di
// module chunks = 0